import { render, staticRenderFns } from "./DelegationStatusChip.vue?vue&type=template&id=04e09666&scoped=true&"
import script from "./DelegationStatusChip.vue?vue&type=script&lang=js&"
export * from "./DelegationStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e09666",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04e09666')) {
      api.createRecord('04e09666', component.options)
    } else {
      api.reload('04e09666', component.options)
    }
    module.hot.accept("./DelegationStatusChip.vue?vue&type=template&id=04e09666&scoped=true&", function () {
      api.rerender('04e09666', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Delegation/DelegationStatusChip.vue"
export default component.exports